import { GridFields } from 'components';
import { useTranslation } from 'libs/i18n';
import { Stack } from 'libs/ui';
import { Section } from 'modules/client/common/components';
import { DocumentsTableFeature } from 'modules/client/common/feature';
import {
  Field,
  useFormContext,
  nameAuthorityMaxLength,
  numberMaxLength,
  registrationDocumentNameLength,
} from 'modules/client/common/forms/companyStateRegistrationForm';
import { getToday } from 'modules/client/common/helpers';

interface Props {
  hideDocuments?: boolean;
  enabledLastStateReRegistrationDate?: boolean;
  isFirstRegistrationDate?: boolean;
}

export const CompanyStateRegistrationSection = ({
  hideDocuments,
  enabledLastStateReRegistrationDate,
  isFirstRegistrationDate = true,
}: Props) => {
  const { t } = useTranslation();
  const { readOnly } = useFormContext();
  return (
    <Section
      datax="companyStateRegistrationSection"
      title={t('client.legal.companyStateRegistration.title')}
    >
      <Stack spacing={24}>
        <GridFields>
          <Field.Text
            fullWidth
            showRequiredMark
            label={t(
              'client.legal.companyStateRegistration.registrationDocumentName.label'
            )}
            maxLength={registrationDocumentNameLength}
            name="companyStateRegistration.registrationDocumentName"
            placeholder={t(
              'client.legal.companyStateRegistration.registrationDocumentName.placeholder'
            )}
          />
          <Field.DatePicker
            fullWidth
            showRequiredMark
            label={
              isFirstRegistrationDate
                ? t(
                    'client.legal.companyStateRegistration.date.labelWithFirstRegistration'
                  )
                : t(
                    'client.legal.companyStateRegistration.date.labelWithoutFirstRegistration'
                  )
            }
            maxDate={getToday()}
            name="companyStateRegistration.date"
            placeholder={t(
              'client.legal.companyStateRegistration.date.placeholder'
            )}
          />
          <Field.Text
            fullWidth
            showRequiredMark
            label={t('client.legal.companyStateRegistration.number.label')}
            maxLength={numberMaxLength}
            name="companyStateRegistration.number"
            placeholder={t(
              'client.legal.companyStateRegistration.number.placeholder'
            )}
          />
          {enabledLastStateReRegistrationDate && (
            <Field.DatePicker
              fullWidth
              label={t(
                'client.legal.companyStateRegistration.lastStateReRegistrationDate.label'
              )}
              maxDate={getToday()}
              name="companyStateRegistration.lastStateReRegistrationDate"
              placeholder={t(
                'client.legal.companyStateRegistration.lastStateReRegistrationDate.placeholder'
              )}
            />
          )}
          <Field.DatePicker
            fullWidth
            showRequiredMark
            disableFuture={false}
            label={t('client.legal.companyStateRegistration.dateOfIssue.label')}
            maxDate={getToday()}
            name="companyStateRegistration.dateOfIssue"
            placeholder={t(
              'client.legal.companyStateRegistration.dateOfIssue.placeholder'
            )}
          />

          <Field.Text
            fullWidth
            showRequiredMark
            label={t(
              'client.legal.companyStateRegistration.nameAuthority.label'
            )}
            maxLength={nameAuthorityMaxLength}
            name="companyStateRegistration.nameAuthority"
            placeholder={t(
              'client.legal.companyStateRegistration.nameAuthority.placeholder'
            )}
          />
        </GridFields>

        {!hideDocuments && (
          <DocumentsTableFeature
            name="companyStateRegistration.files"
            readOnly={readOnly}
          />
        )}
      </Stack>
    </Section>
  );
};
